import { Stack, Typography } from "@mui/material";
import { Customer } from "@/types/customer-type";

interface CustomerAddressInfoProps {
  customer: Customer;
}

export function CustomerAddressInfo({ customer }: CustomerAddressInfoProps) {
  return (
    <Stack spacing={2}>
      <Stack spacing={0.5}>
        <Typography variant="subtitle2" fontWeight={500}>
          Shipping Address
        </Typography>
        {customer.address ? (
          <Typography variant="body2" color="text.secondary">
            {customer.address}
            {customer.address2 && (
              <>
                <br />
                {customer.address2}
              </>
            )}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Not provided
          </Typography>
        )}
        {customer.phone && (
          <Typography variant="body2" color="text.secondary">
            Phone: {customer.phone}
          </Typography>
        )}
      </Stack>
      <Stack spacing={0.5}>
        <Typography variant="subtitle2" fontWeight={500}>
          Billing Address
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Same as shipping address
        </Typography>
      </Stack>
    </Stack>
  );
}
